import { css } from "styled-components";

import { default as breakpoints } from "../shared/breakpoints";
import { spacing2020HasBreakpoints } from "../shared/spacing";

/*********************************************************
 *
 *          reusable heading size constants
 *
 **********************************************************/

export const HeadingXs = {
    mobile: css`
        font-size: 1rem; /*16px*/
        line-height: 150%;
    `,
    tablet: css`
        /* same as MOBILE for this one: */
        font-size: 1rem; /*16px*/
        line-height: 150%;
    `,
    desktop: css`
        font-size: 1.125rem; /*18px*/
        line-height: 160%;
    `
};

export const HeadingSm = {
    mobile: css`
        font-size: 1.125rem; /*18px*/
        line-height: 150%;
        letter-spacing: 0;
    `,
    tablet: css`
        /* same as MOBILE for this one: */
        font-size: 1.125rem; /*18px*/
        line-height: 150%;
        letter-spacing: 0;
    `,
    desktop: css`
        font-size: 1.4063rem; /* 22.5px*/
        line-height: 125%;
        letter-spacing: -0.0019rem;
    `
};

export const HeadingMd = {
    mobile: css`
        font-size: 1.25rem; /* 20px */
        line-height: 1.5625rem;
    `,
    tablet: css`
        font-size: 1.375rem; /* 22px */
        line-height: 125%;
    `,
    desktop: css`
        font-size: 1.75rem; /* 28px*/
        line-height: 125%;
    `
};

export const HeadingLg = {
    mobile: css`
        font-size: 1.5rem; /* 24px */
        line-height: 160%;
    `,
    tablet: css`
        font-size: 1.625rem; /* 26px */
        line-height: 125%;
    `,
    desktop: css`
        font-size: 2.188rem; /* 35px */
        line-height: 125%;
    `
};

export const HeadingXl = {
    mobile: css`
        font-size: 1.625rem; /* 26px*/
    `,
    tablet: css`
        font-size: 2.188rem; /* 35px*/
    `,
    desktop: css`
        font-size: 2.75rem; /* 44px*/
        letter-spacing: -0.0875rem;
    `
};

export const Heading2Xl = {
    mobile: css`
        font-size: 1.875rem; /* 30px */
    `,
    tablet: css`
        font-size: 2.75rem; /* 44px */
    `,
    desktop: css`
        font-size: 3.438rem; /* 55px */
    `
};

export const Heading3Xl = {
    mobile: css`
        font-size: 1.875rem; /* 30px */
    `,
    tablet: css`
        font-size: 3rem; /* 48px */
    `,
    desktop: css`
        font-size: 5rem; /* 80px */
    `
};

export const Heading4Xl = {
    mobile: css`
        font-size: 1.875rem; /* 30px */
    `,
    tablet: css`
        font-size: 3.25rem; /* 52px */
    `,
    desktop: css`
        font-size: 7.5rem; /* 120px */
    `
};

export const handleHeadingSize = ({ size }) => {
    switch (size) {
        case "xs":
            return `
                /* mobile styles: */
                ${HeadingXs.mobile}

                /* tablet styles: */
                @media (min-width: ${breakpoints.md}rem) {
                    ${HeadingXs.tablet}
                }

                /* desktop styles: */
                @media (min-width: ${breakpoints.lg}rem) {
                    ${HeadingXs.desktop}
                }

                /* laptop height styles */
                @media ${breakpoints.laptopHeightsRange} {
                    @media (min-width: ${breakpoints.lg}rem) {
                        ${HeadingXs.tablet}
                    }
                }
            `;
        case "sm":
            return `
                /* mobile styles: */
                ${HeadingSm.mobile}

                /* tablet styles: */
                @media (min-width: ${breakpoints.md}rem) {
                    ${HeadingSm.tablet}
                }

                /* desktop styles: */
                @media (min-width: ${breakpoints.lg}rem) {
                    ${HeadingSm.desktop}
                }

                /* laptop height styles */
                @media ${breakpoints.laptopHeightsRange} {
                    @media (min-width: ${breakpoints.lg}rem) {
                        ${HeadingSm.tablet}
                    }
                }
            `;
        case "md":
            return `
                    /* mobile styles: */
                    ${HeadingMd.mobile}
    
                    /* tablet styles: */
                    @media (min-width: ${breakpoints.md}rem) {
                        ${HeadingMd.tablet}
                    }
    
                    /* desktop styles: */
                    @media (min-width: ${breakpoints.lg}rem) {
                        ${HeadingMd.desktop}
                    }
    
                    /* laptop height styles */
                    @media ${breakpoints.laptopHeightsRange} {
                        @media (min-width: ${breakpoints.lg}rem) {
                            ${HeadingMd.tablet}
                        }
                    }
                `;
        case "lg":
            return `
                    /* mobile styles: */
                    ${HeadingLg.mobile}
    
                    /* tablet styles: */
                    @media (min-width: ${breakpoints.md}rem) {
                        ${HeadingLg.tablet}
                    }
    
                    /* desktop styles: */
                    @media (min-width: ${breakpoints.lg}rem) {
                        ${HeadingLg.desktop}
                    }
    
                    /* laptop height styles */
                    @media ${breakpoints.laptopHeightsRange} {
                        @media (min-width: ${breakpoints.lg}rem) {
                            ${HeadingLg.tablet}
                        }
                    }
                `;
        case "xl":
            return `
                    /* applies to every breakpoint: */
                    line-height: 125%;

                    /* mobile-specific styles: */
                    ${HeadingXl.mobile}
    
                    /* tablet styles: */
                    @media (min-width: ${breakpoints.md}rem) {
                        ${HeadingXl.tablet}
                    }
    
                    /* desktop styles: */
                    @media (min-width: ${breakpoints.lg}rem) {
                        ${HeadingXl.desktop}
                    }
    
                    /* laptop height styles */
                    @media ${breakpoints.laptopHeightsRange} {
                        @media (min-width: ${breakpoints.lg}rem) {
                            ${HeadingXl.tablet}
                        }
                    }
                `;
        case "2xl":
            return `
                    /* applies to every breakpoint: */
                    line-height: 125%;

                    /* mobile-specific styles: */
                    ${Heading2Xl.mobile}
                    letter-spacing: -0.0313rem; /* -0.5px */
    
                    /* tablet styles: */
                    @media (min-width: ${breakpoints.md}rem) {
                        ${Heading2Xl.tablet}
                        letter-spacing: -0.0875rem; /* -1.4px */
                    }
    
                    /* desktop styles: */
                    @media (min-width: ${breakpoints.lg}rem) {
                        ${Heading2Xl.desktop}
                        letter-spacing: 0;
                    }
    
                    /* laptop height styles */
                    @media ${breakpoints.laptopHeightsRange} {
                        @media (min-width: ${breakpoints.lg}rem) {
                            ${Heading2Xl.tablet}
                            letter-spacing: -0.0875rem; /* -1.4px */
                        }
                    }
                `;
        case "3xl":
            return `
                /* mobile styles: */
                ${Heading3Xl.mobile}

                /* tablet styles: */
                @media (min-width: ${breakpoints.md}rem) {
                    ${Heading3Xl.tablet}
                }

                /* desktop styles: */
                @media (min-width: ${breakpoints.lg}rem) {
                    ${Heading3Xl.desktop}
                }

                /* laptop height styles */
                @media ${breakpoints.laptopHeightsRange} {
                    @media (min-width: ${breakpoints.lg}rem) {
                        ${Heading3Xl.tablet}
                    }
                }
            `;
        case "4xl":
            return `
                /* mobile styles: */
                ${Heading4Xl.mobile}

                /* tablet styles: */
                @media (min-width: ${breakpoints.md}rem) {
                    ${Heading4Xl.tablet}
                }

                /* desktop styles: */
                @media (min-width: ${breakpoints.lg}rem) {
                    ${Heading4Xl.desktop}
                }

                /* laptop height styles */
                @media ${breakpoints.laptopHeightsRange} {
                    @media (min-width: ${breakpoints.lg}rem) {
                        ${Heading4Xl.tablet}
                    }
                }
            `;
        default:
            return null;
    }
};

export const handleHeadingSpacing = ({ bottomSpacing }) => {
    switch (bottomSpacing) {
        case "xs":
            return spacing2020HasBreakpoints.SpacingXS;
        case "sm":
            return spacing2020HasBreakpoints.SpacingSM;
        case "md":
            return spacing2020HasBreakpoints.SpacingMD;
        case "lg":
            return spacing2020HasBreakpoints.SpacingLG;
        case "xl":
            return spacing2020HasBreakpoints.SpacingXL;
        case "2xl":
            return spacing2020HasBreakpoints.Spacing2XL;
        case "3xl":
            return spacing2020HasBreakpoints.Spacing3XL;
        case "4xl":
            return spacing2020HasBreakpoints.Spacing4XL;
        case "5xl":
            return spacing2020HasBreakpoints.Spacing5XL;
        default:
            return null;
    }
};
